import clsx from 'clsx';
import React from 'react';

interface StepCounterProps {
  className?: string;
  step: number;
  totalSteps?: number;
}

const StepCounter = ({ className, step, totalSteps = 5 }: StepCounterProps) => {
  return (
    <div
      className={clsx(
        'shrink-0 font-suisse-intl text-button-md',
        className || 'text-grayscale-gray'
      )}
    >
      {step} of {totalSteps}
    </div>
  );
};

export default StepCounter;
